<template>
    <!-- template for the modal component -->
    <!-- <script type="text/x-template" id="modal-template"> -->
    <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <div><input type="text" id="mh" v-model=mhead /></div>
              <!-- default header -->
              <button class="modal-default-button" @click="$emit('close')">x  </button>
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body" @fromgrid="fromgrid">
              <rgrid :gdata=this.gdata :columns=this.columns :footer=this.footer></rgrid>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <div><input type="text" id="mf" v-model=mfoot /></div>
              <!-- default footer -->
                <button class="modal-default-button" @click="$emit('close')">OK</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
// import Rgrid from "./Rgrid.vue"; // - imported in component definition.

export default {
  // register modal component
  name: "Cmodal",
  props: {
    gdata: Array,
    columns: Array,
    footer: String,
    mhead: String,
    mfoot: String
  },
  // components: { Rgrid },
  components: { Rgrid: () => import('./Rgrid.vue') },
  methods: {
    close() {
      this.$emit('close');
    },
    fromgrid() {
      console.log("here I am");
    }
  },
  data() {
    return {
      gridData: [
        { name: "American alligator", location: "Southeast United States", Third: 22221 },
        { name: "Chinese alligator", location: "Eastern China" },
        { name: "Spectacled caiman", location: "Central & South America" },
        { name: "Broad-snouted caiman", location: "South America", Third: 22222 },
        { name: "Jacaré caiman", location: "South America" },
      ],
      gridColumns: ["name", "location", "Third"],
      gridFooter: "Modal Srs:<a href='http://en.wikipedia.org/wiki/List_of_highest-grossing_animated_films' rel='external'>Wikipedia</a> &amp;<a href='http://www.boxofficemojo.com/genres/chart/?id=animation.htm' rel='external'>Box Office Mojo</a>. Data is current as of October 3, 2018.",
    };
  },
  created() {
  }
};
</script>

<style scopped lang="scss">
  @import "../../scss/modal";
</style>
